import useScrollAnimation from "@/hooks/useScrollAnimation";
import { certificationsData } from "@/mocks/homeData";

export default function CertificationsSection() {
  const { ref, isVisible } = useScrollAnimation(0.08);

  return (
    <section id="certifications" className="w-full py-16 md:py-24 bg-background-100">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            {certificationsData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 mt-3 mb-4 leading-tight">
            {certificationsData.headline}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
            {certificationsData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto">
          {certificationsData.certifications.map((cert) => (
            <div
              key={cert.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-accent-50 flex items-center justify-center mb-4">
                <i className={`${cert.icon} text-lg md:text-xl text-accent-500`} />
              </div>
              <h4 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2">
                {cert.name}
              </h4>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {cert.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}